import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    switchContainer: {
      display: 'inline-block',
      flexDirection: 'column',
      position: 'relative',
      width: 120,
      gap: theme.spacing(1),
    },
    switchInnerContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    switchLabel: {
      '& > span': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
      },
    },
    loader: {
      position: 'absolute',
      right: 32,
      top: 8,
    },
    chip: {
      margin: theme.spacing(0.5),
    },
  }),
);
